import { render, staticRenderFns } from "./BearerList.vue?vue&type=template&id=044ae428&"
import script from "./BearerList.vue?vue&type=script&lang=js&"
export * from "./BearerList.vue?vue&type=script&lang=js&"
import style0 from "./BearerList.vue?vue&type=style&index=0&id=044ae428&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports